"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ConnectedMessage() {
  return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "is-connected-check-details icon-check icon-size-md"
  }), /*#__PURE__*/_react.default.createElement("h4", {
    className: "connection-message"
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "Connected"
  })));
}
var _default = exports.default = ConnectedMessage;